import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MainAppMenuService } from '../../services/main-app-menu.service';
import { UserData } from 'src/app/services/api/user.service';
import { UserAuthService } from 'src/app/services/user/user-auth.service';

@Component({
  selector: 'app-main-app-dashboard-home',
  templateUrl: './main-app-dashboard-home.component.html',
  styleUrls: ['./main-app-dashboard-home.component.scss']
})
export class MainAppDashboardHomeComponent implements OnDestroy {

  mapVisible: boolean = false;
  userData?: UserData | null
  private userSub! : Subscription;

  constructor(
    private router: Router,
    public user: UserAuthService,
    private menu: MainAppMenuService
  ) {
      this.userSub = this.user.getUserDataSubject().subscribe(data => {
        this.userData = data;

        // this.getData();
      })
  }

  ngOnDestroy(): void {
    this.userSub?.unsubscribe();
  }
}
